// extracted by mini-css-extract-plugin
export default {"items":"A8TurdMl58hKu_svzygy"};